import { FocusedLineItemStrip, FocusedLineItemStripButton, FocusedLineItemStripMessage } from './FocusedLineItemStrip';

/**
 * The strip under a line whose product replaces its template's: the product it replaced, struck through, and
 * both ways back. Restore original puts the template's product back, unless it's out of stock; Change product
 * shops for another.
 */
export const FocusedLineItemProductOverrideStrip = ({
  originalTitle,
  originalIsOutOfStock,
  onRestoreOriginal,
  onChangeProduct,
}: {
  originalTitle?: string;
  originalIsOutOfStock: boolean;
  onRestoreOriginal?: () => void;
  onChangeProduct: () => void;
}) => (
  <FocusedLineItemStrip
    testId='focused-line-item-product-override-strip'
    actions={
      <>
        <FocusedLineItemStripButton isSecondary disabled={originalIsOutOfStock || !onRestoreOriginal} onClick={onRestoreOriginal}>
          Restore original
        </FocusedLineItemStripButton>
        <FocusedLineItemStripButton isSecondary onClick={onChangeProduct}>Change product</FocusedLineItemStripButton>
      </>
    }
  >
    <FocusedLineItemStripMessage>
      {'Replaced '}
      <s>{originalTitle ?? "the template's product"}</s>
      {originalIsOutOfStock && (
        <>
          {' · '}
          <em>{'still out of stock'}</em>
        </>
      )}
    </FocusedLineItemStripMessage>
  </FocusedLineItemStrip>
);
